import React from "react";
import {
  ActiveInvoiceArrivalContext,
  ActiveInvoiceArrivalItemContext,
  ActiveInvoiceArrivalType,
} from "./context";
import { InvoiceArrival } from "@towersystems/roam-common/lib/generated-types";

export const useInvoiceArrival = (
  invoiceArrival: InvoiceArrival
): ActiveInvoiceArrivalType => {
  const [activeInvoiceArrival, _setActiveInvoiceArrival] =
    React.useState(invoiceArrival);

  const setInvoiceArrival = React.useCallback(
    (invoiceArrival: InvoiceArrival) => {
      _setActiveInvoiceArrival(invoiceArrival);
    },
    [_setActiveInvoiceArrival]
  );

  return {
    invoiceArrival: activeInvoiceArrival,
    setInvoiceArrival,
  };
};
export const useInvoiceArrivalContextProvider = () => {
  const context = React.useContext(ActiveInvoiceArrivalContext);
  if (!context) {
    throw new Error("No ActiveInvoiceArrivalContext context was provided.");
  }
  return context;
};

export const useActiveInvoiceArrivalItemProvider = () => {
  const context = React.useContext(ActiveInvoiceArrivalItemContext);
  if (!context) {
    throw new Error("No ActiveInvoiceArrivalItemContext context was provided.");
  }
  return context;
};
